module.exports = fox._r("images/maintenance.png", __webpack_public_path__ + "_/_/_/common/frame/images/maintenance.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/maintenance.png
// module id = 140
// module chunks = 2